import { GlobalAxios } from "../axios/axios-config";
import {
  IListImportAutomationClassificationGetById,
  INewListImportAutomationClassification,
} from "../models/list-import-automation-classificaton";

const CLASSIFICATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListImportAutomationClassification";

export const createClassification = (
  params: INewListImportAutomationClassification,
) => {
  return GlobalAxios.post(CLASSIFICATION_ROUTE, params);
};

export const getClassificationById = (id: string) => {
  return GlobalAxios.get<IListImportAutomationClassificationGetById>(
    CLASSIFICATION_ROUTE + "/" + id,
  );
};

export const updateClassification = ({
  id,
  item,
}: {
  id: string;
  item: INewListImportAutomationClassification;
}) => {
  return GlobalAxios.put(CLASSIFICATION_ROUTE + "/" + id, item);
};
